import { render, staticRenderFns } from "./MacroregionsTable.vue?vue&type=template&id=31da418e&"
import script from "./MacroregionsTable.vue?vue&type=script&lang=js&"
export * from "./MacroregionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports